import React from 'react'
import RestrictPage from './views/Restrict'
import ConnectorAI from './views/connectors/AI'
import ConnectorERP from './views/connectors/ERP'
import AgentEmail from './views/agents/email/Email'
import AgentEmailMessages from './views/agents/email/EmailMessages'
import Role from './views/administration/Role'
import Log from './views/system/Logs'
import ConnectorEmailOffice365 from './views/connectors/EmailOffice365'

const Home = React.lazy(() => import('./views/Home'))
const User = React.lazy(() => import('./views/administration/User'))

const routes = [
  {
    path: '',
    exact: true,
    name: 'Home',
    element: Home,
    permission: 'authenticated',
  },
  {
    path: '/users',
    exact: true,
    name: 'Users',
    element: User,
    permission: 'user-read',
  },
  {
    path: '/roles',
    exact: true,
    name: 'Roles',
    element: Role,
    permission: 'role-read',
  },
  {
    path: '/restriction',
    exact: true,
    name: 'Restriction',
    element: RestrictPage,
  },
  {
    path: '/connectors/email-office365',
    exact: true,
    name: 'EmailOffice365Connectors',
    element: ConnectorEmailOffice365,
    permission: 'connector-read',
  },
  {
    path: '/connectors/ai',
    exact: true,
    name: 'AIConnectors',
    element: ConnectorAI,
    permission: 'connector-read',
  },
  {
    path: '/connectors/erp',
    exact: true,
    name: 'ERPConnectors',
    element: ConnectorERP,
    permission: 'connector-read',
  },
  {
    path: '/agents/emails',
    exact: true,
    name: 'EmailAgents',
    element: AgentEmail,
    permission: 'agent-read',
  },
  {
    path: '/emails',
    exact: true,
    name: 'EmailAgentMessages',
    element: AgentEmailMessages,
    permission: 'agent-email-message-read',
  },
  {
    path: '/logs',
    exact: true,
    name: 'Log',
    element: Log,
    permission: 'log-read',
  },
  {
    path: '/terms',
    exact: true,
    name: 'Terms',
    element: () => <div>Terms</div>,
  },
  {
    path: '/privacy',
    exact: true,
    name: 'Privacy',
    element: () => <div>Privacy</div>,
  },
]

export default routes
